import { useQuery } from "@tanstack/react-query"
import { goalsQuery } from "modules/campaigns/lib/goals/goalsQuery"

export function useGoalsQuery(...args: Parameters<typeof goalsQuery>) {
  return useQuery(goalsQuery(...args))
}
